import { useState, useEffect } from 'react';
import { fetchCompetitions } from '../api/api';

export function useCompetitions() {
  const [competitions, setCompetitions] = useState([]);

  useEffect(() => {
    fetchCompetitions()
    .then(json => {
      setCompetitions(json)
    })
  }, []);

  return competitions;
}